module.exports = __webpack_public_path__ + "media/fonts/Roboto/Roboto-Bold-3f2cbde6b72e8d05669fb048b5ebc20f.woff";